import styles from "./footer.module.css";
import Image from "next/image";
import { Figtree } from "next/font/google";
import { Link } from "@/i18n/navigation";
import { useLocale, useTranslations } from "next-intl";
import {
  FaFacebook,
  FaInstagram,
  FaRegCopyright,
  FaXTwitter,
} from "react-icons/fa6";
import { makeLocalizedHrefNoLocale } from "@/lib/localizedRoutes/routeHelpers";

const figtree = Figtree({ weight: ["400", "500", "600"], subsets: ["latin"] });

export default function Footer({
  isDialogFooter,
}: {
  isDialogFooter?: boolean;
}) {
  const t = useTranslations("Footer");
  const locale = useLocale();
  return (
    <footer
      className={`${styles.footer} ${isDialogFooter && styles.isDialogFooter}`}
    >
      <div className={styles.footerWrapper}>
        <div className={styles.linksWrapper}>
          <div className={styles.clientsRow}>
            <h2 className={figtree.className}>{t("forOurClients")}</h2>
            <Link href="">{t("sellOnDoomum")}</Link>
            <Link href="">{t("adviceBuyers")}</Link>
            <Link href="">{t("rentingOnDoomum")}</Link>
            <Link href={makeLocalizedHrefNoLocale(locale, "pricing")}>
              {t("fees")}
            </Link>
          </div>
          <div className={styles.separator}></div>
          <div className={styles.doomumRow}>
            <h2 className={figtree.className}>Doomum.com</h2>
            <div className={styles.columnsWrapper}>
              <div className={styles.column}>
                <Link href="">{t("aboutUs")}</Link>
                <Link href={makeLocalizedHrefNoLocale(locale, "contact")}>
                  {t("contactUs")}
                </Link>
                <Link href={makeLocalizedHrefNoLocale(locale, "terms-of-use")}>
                  {t("termsOfUse")}
                </Link>
                <Link href={makeLocalizedHrefNoLocale(locale, "refund-policy")}>
                  {t("refundPolicy")}
                </Link>
              </div>
              <div className={styles.column}>
                <Link
                  href={makeLocalizedHrefNoLocale(locale, "privacy-policy")}
                >
                  {t("dataPrivacy")}
                </Link>
                <Link
                  href={makeLocalizedHrefNoLocale(locale, "cookies-policy")}
                >
                  {t("cookiePolicy")}
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className={`${styles.separator} ${styles.separator2}`}></div>
        <div className={styles.socialRow}>
          <div className={styles.socialContent}>
            <div>
              <h2 className={figtree.className}>{t("followUs")}</h2>
              <span className={styles.iconsRow}>
                <FaInstagram />
                <FaFacebook />
                <FaXTwitter />
              </span>
            </div>
            <Image
              src="/logo_black.png"
              alt="Doomum logo black color."
              width={210}
              height={55}
            />
          </div>
          <span className={styles.copyrightColumn}>
            <FaRegCopyright />
            <p className={figtree.className}>
              {`${new Date().getFullYear()}` + " " + t("allRights")}
            </p>
          </span>
        </div>
      </div>
    </footer>
  );
}
